// extracted by mini-css-extract-plugin
export default {"logout-page":"logout_logout-page__2u+3P"};